import React from 'react';
import { Icon, Pagination } from 'semantic-ui-react';

class PaginationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    const { activePage, totalPages, disabled } = this.props;
    return totalPages > 1 && (
      <Pagination
        activePage={activePage}
        totalPages={Math.ceil(totalPages)}
        onPageChange={(e, d) => this.props.onPageChange(e, d)}
        disabled={disabled}
        ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
        firstItem={{ content: <Icon name='angle double left' />, icon: true }}
        lastItem={{ content: <Icon name='angle double right' />, icon: true }}
        prevItem={{ content: <Icon name='angle left' />, icon: true }}
        nextItem={{ content: <Icon name='angle right' />, icon: true }}
      />
    )
  }
}
export default PaginationComponent;